export const version = 'kunde-v1.20.0-SNAPSHOT-68a2c5b4103017eabfa0633217f37719ae5acc7d';